import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

import {OttopilotAnnouncementsWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotAnnouncementsWorkspaceCapability/domain/OttopilotAnnouncementsWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type OttopilotAnnouncementsWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.ottopilotAnnouncements> & {
    fixedUdoTemplates: {
        [OttopilotAnnouncementsWorkspaceCapabilityUdoTemplateKey.announcement]: {
            udoAdditionalColumnIds: {
                content: Uuid;
                status: Uuid;
                validUserTemplateIds: Uuid;
            };
        };
        [OttopilotAnnouncementsWorkspaceCapabilityUdoTemplateKey.tracking]: {
            udoAdditionalColumnIds: {
                announcementId: Uuid;
                disposition: Uuid;
                status: Uuid;
                userId: Uuid;
            };
        };
    };
};

export const ottopilotAnnouncementsWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [OttopilotAnnouncementsWorkspaceCapabilityUdoTemplateKey.announcement]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({content: uuidZodValidator, status: uuidZodValidator, validUserTemplateIds: uuidZodValidator}),
            udoTemplateId: uuidZodValidator,
        }),
        [OttopilotAnnouncementsWorkspaceCapabilityUdoTemplateKey.tracking]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({announcementId: uuidZodValidator, disposition: uuidZodValidator, status: uuidZodValidator, userId: uuidZodValidator}),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<OttopilotAnnouncementsWorkspaceCapabilityUdoBindings>;
